// Una opcion que se elige: su icono arriba, su nombre debajo, y un punto cuando
// esta puesta.
//
// Estaba dibujada dos veces en el constructor de filtros -los canales y las
// categorias de contacto-, con `<button>` crudo, `min-h-[80px]` y `min-h-[70px]`
// y dos bordes distintos para decir lo mismo. Son la misma tarjeta.
//
// Se apoya en `size="tarjeta"` del boton, que es donde vive que una tarjeta no
// tiene altura fija: la decide lo que lleva dentro.

import * as React from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export function TarjetaElegible({
  icono,
  nombre,
  elegida,
  onElegir,
  className,
}: {
  icono: React.ReactNode
  nombre: React.ReactNode
  elegida?: boolean
  onElegir: () => void
  className?: string
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="tarjeta"
      onClick={onElegir}
      aria-pressed={elegida}
      className={cn(
        'group relative items-center justify-center gap-2 text-center',
        elegida
          ? 'border border-primary bg-primary/5'
          : 'border border-transparent bg-card hover:bg-muted/30',
        className,
      )}
    >
      <span
        className={cn(
          'flex h-8 w-8 items-center justify-center rounded-lg transition-colors',
          elegida ? 'bg-primary/10' : 'bg-muted/50 group-hover:bg-primary/5',
        )}
      >
        {icono}
      </span>
      <span className="whitespace-normal text-xs font-medium leading-tight text-foreground transition-colors group-hover:text-primary">
        {nombre}
      </span>
      {elegida && <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-primary" />}
    </Button>
  )
}
